module.exports = __webpack_public_path__ + "static/media/posture5.8a2bd3dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posture5.jpg
// module id = 199
// module chunks = 0